import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { poppinsCustomTheme } from "../../Styles/GlobalStyles/PoppinsTheme";
import { ThemeProvider } from "@mui/material/styles";
import Slide from "@mui/material/Slide";
import { DialogGreyOutlinedButton } from "../Button/CustomButton";
import { colors } from "../../Styles/GlobalStyles/Variables";
import CloseIcon from "@mui/icons-material/Close";
import LoadingButton from "@mui/lab/LoadingButton";
import {
    Divider,
    FormControl,
    IconButton,
    Skeleton,
    TextField,
    Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import {
    StyledDialogActions,
    StyledDialogTitle,
    StyledLeftBox,
    StyledRightBox,
} from "../MangeSuccessfulBusiness/dialogStyles/DialogStyles";
import ConfirmDialog from "../Alert/ConfirmDialog";
import ViewForm from "./ViewForm";


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function UserDialog({
    title,
    open,
    handleClose,
    loadingButton,
    handleFormUpdate,
    showSkeleton,
    handleChange,
    formValues,
    fireApi,
    stateValue,
    error,
    data,
    values,
    lga,
    lgaValue
}) {
    const ToastStyle = {
        backgroundColor: "#d56b66",
        color: colors.white,
    };

    const [confirmDialog, setConfirmDialog] = useState({
        isOpen: false,
        isLoading: false,
        title: "",
        subTitle: "",
        header: "",
        backgroundColor: "",
        borderSideColor: "",
        color: "",
        subColor: "",
        note: false,
    });

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));


    return (
        <ThemeProvider theme={poppinsCustomTheme}>
            <Dialog
                fullWidth={true}
                fullScreen={fullScreen}
                maxWidth={"md"}
                open={open}
                TransitionComponent={Transition}
                keepMounted
                aria-labelledby="draggable-dialog-title"
                PaperProps={{
                    style: { borderRadius: 20, overflow: "hidden", height: "100%", position: 'relative' },

                }}
            >
                <Box
                    height="100%"
                    display="flex"
                    flexDirection="row"
                    flexWrap="wrap"
                    sx={{
                        [theme.breakpoints.down("md")]: {
                            flexDirection: "column",
                        },
                    }}
                >
                    <StyledLeftBox>
                        <Box sx={{ mt: "20px" }}>
                            {/* <StyledDivider textAlign="left"> */}
                            <Typography
                                variant="subtitle2"
                                sx={{ color: "#949494", ml: 1 }}
                            >
                                {title.left ?? ''}
                            </Typography>
                            {/* </StyledDivider> */}
                            <FormControl sx={{ margin: "20px 10px", width: "100%" }}>
                                {
                                    showSkeleton ? (
                                        <Skeleton
                                            variant="rounded"
                                            animation="wave"
                                            height={40}
                                            width={200}
                                        />
                                    ) : (
                                        <TextField
                                            id="fullName"
                                            label="Full Name"
                                            value={values?.firstName + " " + values?.lastName}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            variant="standard"
                                        />
                                    )}
                            </FormControl>
                            <FormControl sx={{ margin: "20px 10px", width: "100%" }}>
                                {showSkeleton ? (
                                    <Skeleton
                                        variant="rounded"
                                        animation="wave"
                                        height={40}
                                        width={200}
                                    />
                                ) : (
                                    <TextField
                                        id="staffNo"
                                        label="Staff No"
                                        value={values?.staffNo}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        variant="standard"
                                    />)}
                            </FormControl>
                            <FormControl sx={{ margin: "20px 10px", width: "100%" }}>

                                {showSkeleton ? (
                                    <Skeleton
                                        variant="rounded"
                                        animation="wave"
                                        height={40}
                                        width={200}
                                    />
                                ) : (
                                    <TextField
                                        id="email"
                                        label="Email"
                                        value={values?.email}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        variant="standard"
                                    />)}

                            </FormControl>

                            <FormControl sx={{ margin: "20px 10px", width: "100%" }}>

                                {showSkeleton ? (
                                    <Skeleton
                                        variant="rounded"
                                        animation="wave"
                                        height={40}
                                        width={200}
                                    />
                                ) : (
                                    <TextField
                                        id="phoneNumber"
                                        label="Phone Number"
                                        value={`+234 ${values?.phoneNumber}`}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        variant="standard"
                                    />)}

                            </FormControl>
                            <FormControl sx={{ margin: "20px 10px", width: "100%" }}>

                                {showSkeleton ? (
                                    <Skeleton
                                        variant="rounded"
                                        animation="wave"
                                        height={40}
                                        width={200}
                                    />
                                ) : (
                                    <TextField
                                        id="lga"
                                        label="LGA"
                                        value={lga}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        variant="standard"
                                    />)}

                            </FormControl>
                        </Box>
                    </StyledLeftBox>
                    <div style={StyledRightBox}>
                        <StyledDialogTitle id="responsive-dialog-title">
                            {title.right ?? ''}
                            <IconButton onClick={handleClose}>
                                <CloseIcon />
                            </IconButton>
                        </StyledDialogTitle>
                        <Divider />
                        <DialogContent
                            sx={{ padding: "20px 10px", textTransform: "capitalize" }}
                        >
                            <ViewForm
                                handleChange={handleChange}
                                formValues={formValues}
                                fireApi={fireApi}
                                stateValue={stateValue}
                                error={error}
                                data={data}
                                lgaValue={lgaValue}
                            />

                        </DialogContent>
                        <Divider />
                        <StyledDialogActions style={{ position: 'absolute', bottom: 20, right: 20 }}>

                            <DialogGreyOutlinedButton
                                sx={{
                                    textTransform: "capitalize",
                                    padding: "10px 30px",
                                    margin: "10px",
                                }}
                                onClick={handleClose}
                            >
                                close
                            </DialogGreyOutlinedButton>
                            <LoadingButton
                                loading={loadingButton}
                                loadingIndicator="Saving..."
                                onClick={() => handleFormUpdate()}
                                disableElevation
                                startIcon={<SaveAsIcon icon="icon-park-outline:edit" />}
                                sx={{
                                    textTransform: "capitalize",
                                    color: "#fff",
                                    borderColor: colors.primaryGreen,
                                    "&:hover": { borderColor: colors.primaryGreen },
                                    padding: "10px 30px",
                                }}
                                variant="contained"
                            >
                                Save Changes
                            </LoadingButton>
                        </StyledDialogActions>
                    </div>
                </Box>
                <ToastContainer toastStyle={ToastStyle} />
                <ConfirmDialog
                    confirmDialog={confirmDialog}
                    setConfirmDialog={setConfirmDialog}
                />
            </Dialog>
        </ThemeProvider>
    );
}
